import { render, staticRenderFns } from "./BreadcrumbsLink.vue?vue&type=template&id=3eeaf785&scoped=true&"
import script from "./BreadcrumbsLink.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbsLink.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbsLink.vue?vue&type=style&index=0&id=3eeaf785&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeaf785",
  null
  
)

export default component.exports